import useSecuredApiService from './useSecuredApiService'

const usePlatformService = () => {
  const { getApiData, postApiData, getApiDataWithParams, putApiData, deleteApiData } =
    useSecuredApiService()

  const getPaged = async (params) => {
    return await getApiDataWithParams('/Platform/getPaged', params)
  }
  const getAll = async (id) => {
    return getApiData('/Platform/getAll')
  }
  const getById = async (id) => {
    return getApiData('/Platform/GetById?id=' + id)
  }
  const getWithAddressById = async (id) => {
    return getApiData('/Platform/GetWithAddressById?id=' + id)
  }
  const create = async (data) => {
    return postApiData('/Platform/CreatePlatformAndAddress', data)
  }
  const update = async (id, data) => {
    return putApiData('/Platform/Edit?id=' + id, data)
  }
  const remove = async (id) => {
    return deleteApiData('/Platform/Delete?id=' + id)
  }

  return {
    getPaged,
    getById,
    getWithAddressById,
    getAll,
    create,
    update,
    remove,
  }
}

export default usePlatformService
